import { SupplierSubscriptionPlan } from '../../../types/SupplierGroupSubscriptionMessage';
import { translate } from '../../common/helpers/translate.helper';
import { SidebarMenuItem } from '../../common/Sidebar/components/SidebarMenuItem';
import { useSupplierSubscriptionPlans } from '../useSupplierSubscriptionPlans';

interface SupplierSubscriptionPlansMenuItemProps {
    closeMenu: () => void;
}

export const SupplierSubscriptionPlansMenuItem = ({ closeMenu }: SupplierSubscriptionPlansMenuItemProps) => {
    const { canViewPlans, currentPlan, openPlans } = useSupplierSubscriptionPlans();
    if (!canViewPlans || currentPlan === undefined || currentPlan === SupplierSubscriptionPlan.ENTERPRISE) {
        return null;
    }
    return (
        <SidebarMenuItem
            onClick={() => {
                closeMenu();
                openPlans();
            }}
        >
            {translate('supplierSubscriptionPlans.upgradePlan')}
        </SidebarMenuItem>
    );
};
